module.exports = require('./_hide');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_redefine.js
// module id = ./node_modules/core-js/library/modules/_redefine.js
// module chunks = index